import axios, { AxiosResponse } from "axios";
import { v4 as uuidV4 } from "uuid";
import { isDemo } from "@/utils";

let instance = null;

class AuthService {
    private sessionToken = "";
    private userId = "";

    constructor() {
        this.sessionToken = localStorage.getItem("stqr_token") || "";
        this.userId = localStorage.getItem("stqr_uid") || "";
    }

    checkAuth(): Promise<{
        success: boolean;
        role: string;
        is_argo_user: boolean;
    }> {
        return axios.get(`auth/check`);
    }

    register(
        name: string,
        email: string,
        password: string
    ): Promise<{ session: string; userId: string }> {
        if (isDemo()) {
            throw new Error("notInDemo");
        }
        const deviceId = uuidV4();
        return axios.post("auth/signup", {
            name,
            email,
            password,
            deviceId
        });
    }

    async signInWithGoogle(token: string) {
        const response = await axios.post("auth/google/signIn", {
            token
        });

        return response.data;
    }

    login(
        email: string,
        password: string
    ): Promise<{
        session: string;
        userId: string;
    }> {
        return axios
            .post("auth/login", {
                email,
                password
            })
            .then(response => response.data);
    }

    async forgetPassword(email: string): Promise<AxiosResponse> {
        if (isDemo()) {
            throw new Error("notInDemo");
        }
        return await axios.post("auth/recovery/perform", {
            email
        });
    }
}

function getInstance(): AuthService {
    if (!instance) {
        instance = new AuthService();
    }

    return instance;
}

export default getInstance;
